import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import Card from '@welldev-group/rcl-card';
import { I18nText } from '@welldev-group/react-comp-lib';
import news from 'affiliateIcons/news-placeholder.svg';
import DateTime from '../DateTime';

const NewsCard = ({ teaser, imageUrl, newsLink, author, createdAt }) => {
  const image = imageUrl != null ? imageUrl : news;
  const isSmallScreen = window.innerWidth < 767;

  return (
    <div
      className={ClassNames({
        'news-card__wrapper': isSmallScreen,
        'col-12 news-card__wrapper--small': !isSmallScreen,
      })}
    >
      <Card version="v2" className="news-card__card">
        <a href={newsLink}>
          <div className="news-card grid">
            <div className="news-card__image col-lg-3 col-md-3 col-12 col-bleed">
              <img src={image} alt="news" />
            </div>
            <div className="col-lg-9 col-md-9 col-12 col-grid justify-center">
              <div className="news-card__date hidden-xxs hidden-xs hidden-sm">
                <DateTime dateTime={createdAt} format="short" />
              </div>
              <div className="news-card__teaser">{teaser}</div>

              <div className="news-card__author hidden-xxs hidden-xs hidden-sm">
                {author && (
                  <span>
                    <I18nText id="dashboard.news.by" /> {author}
                  </span>
                )}
              </div>

              <div className="hidden-xlg hidden-lg hidden-md">
                <div className="news-card__footer">
                  <div className="news-card__author">
                    {author && (
                      <span>
                        <I18nText id="dashboard.news.by" /> {author}
                      </span>
                    )}
                  </div>
                  <div>
                    <div className="news-card__date">
                      <DateTime dateTime={createdAt} format="short" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </Card>
    </div>
  );
};

NewsCard.defaultProps = {
  imageUrl: null,
  author: null,
};

NewsCard.propTypes = {
  teaser: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  newsLink: PropTypes.string.isRequired,
  author: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
};

export default NewsCard;
